import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import MathJax from "react-mathjax2";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";

interface CustomReactMarkDownProps {
  content: string;
}

const CustomReactMarkDown: React.FC<CustomReactMarkDownProps> = ({
  content,
}) => {
  const theme = useTheme();

  const isLessThanSmall: boolean = useMediaQuery(theme.breakpoints.down("sm"));
  const isLessThanLarge: boolean = useMediaQuery(theme.breakpoints.down("lg"));

  const fontSize: string = isLessThanSmall
    ? "0.8rem"
    : isLessThanLarge
      ? "0.9rem"
      : "1rem";

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        p(props) {
          const { children } = props;
          // This regex matches a string that contains a LaTeX expression
          // LaTeX expressions are wrapped in square brackets.
          // For example: [x^2]
          const regex = /\\?\[(\\?[^\\]|\\\\[\[\]])*\\?\]/g;
          if (typeof children !== "string") return <p> {children} </p>;
          const match = children.match(regex);
          return match ? (
            <Box fontSize={"12px"} overflow={"scroll"}>
              <Grid size={{ xs: 1, lg: 1 }}>
                <MathJax.Context input="tex">
                  <MathJax.Node>{children}</MathJax.Node>
                </MathJax.Context>
              </Grid>
            </Box>
          ) : (
            <p
              style={{
                fontSize: fontSize,
              }}
            >
              {children}
            </p>
          );
        },
        table: ({ node, ...props }) => (
          <table className={"tallyTable"} {...props} />
        ),
        pre: ({ node, ...props }) => <pre className={"tallyCode"} {...props} />,
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default CustomReactMarkDown;
